var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__clock--system icon--style--outline icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 3a9 9 0 11-9 9 9 9 0 019-9m0-2a11 11 0 1011 11A11 11 0 0012 1zm4.707 15.707a1 1 0 000-1.414L13 11.586V6a1 1 0 00-2 0v6a1 1 0 00.293.707l4 4a1 1 0 001.414 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }